import { Paper } from "@mui/material";
import { Collections, ConfirmationNumber, Storage } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { useAccount } from "wagmi";

import { ChainLinkV2SupportedChains } from "@framework/types";
import { NodeEnv } from "@dzambalaorg/constants";
import { List } from "@dzambalaorg/ui-kit";

const data = [
  { text: "pages.prediction.contracts.title", link: "/prediction/contracts", icon: <Collections /> },
  { text: "pages.prediction.questions.title", link: "/prediction/questions", icon: <ConfirmationNumber /> },
  { text: "pages.prediction.answers.title", link: "/prediction/answers", icon: <Storage /> },
];

export const PredictionSection = () => {
  const isProd = process.env.NODE_ENV === NodeEnv.production;
  const { chainId = 0 } = useAccount();

  if (isProd) {
    return null;
  }

  if (process.env.NODE_ENV === NodeEnv.production && !ChainLinkV2SupportedChains[chainId]) {
    return null;
  }

  return (
    <Paper sx={{ mb: 2 }}>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.mechanics.prediction" />
          </List.Subheader>
        }
      >
        {data.map(({ text, icon, link }) => (
          <List.ItemButton<typeof RouterLink> key={text} component={RouterLink} to={link}>
            <List.ItemIcon>{icon}</List.ItemIcon>
            <List.ItemText>
              <FormattedMessage id={text} />
            </List.ItemText>
          </List.ItemButton>
        ))}
      </List>
    </Paper>
  );
};
